import { request } from '@langlois/request';

export async function create ({ commit }, { data, clubId }) {
	try {
		const body = new FormData();

		for (let [key, value] of Object.entries(data)) {
			if (value) body.append(key, value);
		}

		const url = new URL(`${process.env.VUE_APP_API_URI}/club/club/${clubId}/competition`);

		const response = await request.post(url, body);

		if (response.ok) {
			const { id } = await response.json();

			commit(`setCompetition`, {
				clubId,
				...data,
				id
			});
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while creating the competition.`,
			type: `warning`
		}, { root: true });
	}
}
